import LineChart from '@c/charts/LineChart';
import { useQuery } from '@tanstack/react-query';
import { getBikeGraph } from '@util/firestore/products';
import { formatCurrency } from '@util/index';
import { ProductDocument } from '@models/product';
import React from 'react';

const PriceGuideChart = ({ product }: { product: ProductDocument }) => {
  const hasProductDetails = !!product.year && !!product.make && !!product.model;

  const { data: bikeGraph } = useQuery({
    queryKey: ['bikeGraph', product.year, product.make, product.model],
    queryFn: () => getBikeGraph(product.year!, product.make!, product.model!),
    enabled: hasProductDetails,
  });

  const bikeGraphChart = {
    labels: bikeGraph?.soldDates.map((date) =>
      new Date(date).toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
      })
    ),
    datasets: [
      {
        label: 'sold',
        data: bikeGraph?.prices,
        borderColor: '#C41719',
        pointBackgroundColor: '#C41719',
        borderWidth: 2,
        fill: true,
        backgroundColor: ['rgba(196, 23, 25, 0.2)'],
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    responsive: true,
    aspectRatio: 3.4,
    scales: {
      y: {
        title: {
          display: true,
          text: 'Price',
        },
      },
      x: {
        title: {
          display: true,
          text: 'Date',
        },
      },
    },
  };

  if (!bikeGraph || bikeGraph.count < 3) return null;

  return (
    <div className="mx-auto w-full max-w-[120rem] py-[4rem]  md:py-[6.4rem]">
      <div className="mb-[4rem] flex justify-between gap-3">
        <div>
          <p className="mb-[0.8rem] text-[1.6rem] font-semibold text-brand-mid-green md:text-[1.8rem] ">
            Pricing Guide
          </p>
          <p className="text-[1.8rem] font-semibold md:text-[2.4rem]">
            {product.year} {product.make} {product.model}
          </p>
          <p className="text-[1.4rem] text-brand-extreme-lightest-black">
            *Based on {bikeGraph?.count} sold on MX Locker
          </p>
        </div>
        <div>
          <p className="text-[1.6rem] ">Average Price</p>
          <p className="text-[1.8rem] font-semibold md:text-[2.4rem]">
            {formatCurrency(bikeGraph?.avg ?? 0)}
          </p>
        </div>
      </div>
      <LineChart chartData={bikeGraphChart} options={options} />
    </div>
  );
};

export default PriceGuideChart;
